import _requireObjectCoercible from "../internals/require-object-coercible";
var exports = {};
var requireObjectCoercible = _requireObjectCoercible;
var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};
export default exports;